import { color } from "style/constants";

export default {
  active: {
    color: color.BLUE
  }
};
